<template>
  <!-- 管理员后台主布局：深蓝色侧边栏 + 白色头部 + 内容区 -->
  <el-container class="admin-layout">
    <!-- 深蓝色侧边栏导航（vue-element-admin 风格） -->
    <el-aside class="admin-sidebar">
      <!-- 侧边栏顶部标题 -->
      <div class="sidebar-title">云伴展后台</div>
      <!-- 可滚动的菜单区域 -->
      <el-scrollbar wrap-class="scrollbar-wrapper">
        <el-menu
            :default-active="activeMenu"
            :default-openeds="openedMenus"
            background-color="#304156"
            text-color="#bfcbd9"
            active-text-color="#409eff"
            router
          >
            <!-- 首页 -->
            <el-menu-item index="/admin/index">
              <i class="el-icon-s-home"></i>
              <span>首页</span>
            </el-menu-item>

            <!-- 配对会/考察团 -->
            <el-submenu index="matching">
              <template slot="title">
                <i class="el-icon-s-flag"></i>
                <span>国外考察团</span>
              </template>
              <el-menu-item index="/admin/cnGlobalList?type=10">202606泰国</el-menu-item>
              <el-menu-item index="/admin/cnGlobalList?type=9">2026马来西亚</el-menu-item>
              <el-menu-item index="/admin/cnGlobalList?type=8">202604泰国</el-menu-item>
              <el-menu-item index="/admin/cnGlobalList?type=7">2025越南</el-menu-item>
              <el-menu-item index="/admin/cnGlobalList?type=6">2025马来西亚</el-menu-item>
              <el-menu-item index="/admin/cnGlobalList?type=5">2025泰国</el-menu-item>
              <el-menu-item index="/admin/cnGlobalList?type=4">2024越南</el-menu-item>
              <el-menu-item index="/admin/cnGlobalList?type=1">2024泰国</el-menu-item>
            </el-submenu>

            <!-- 推广活动 -->
            <el-submenu index="promotion">
              <template slot="title">
                <i class="el-icon-s-marketing"></i>
                <span>推广活动</span>
              </template>
              <el-menu-item index="/admin/promotion?type=1">中文网</el-menu-item>
              <el-menu-item index="/admin/promotion?type=2">英文网</el-menu-item>
              <el-menu-item index="/admin/promotion?type=3">培训</el-menu-item>
              <el-menu-item index="/admin/promotion?type=5">东南亚论坛配对会</el-menu-item>
              <el-menu-item index="/admin/promotion?type=6">新媒体</el-menu-item>
              <el-menu-item index="/admin/promotion?type=7">轴承网</el-menu-item>
              <el-menu-item index="/admin/promotion?type=8">Facebook</el-menu-item>
            </el-submenu>

            <!-- 东南亚服务中心 -->
            <el-menu-item index="/admin/tha_liaison_index">
              <i class="el-icon-s-promotion"></i>
              <span>东南亚服务中心</span>
            </el-menu-item>

            <!-- 参观参展 -->
            <el-submenu index="visitors">
              <template slot="title">
                <i class="el-icon-user"></i>
                <span>参观参展</span>
              </template>
              <el-menu-item index="/admin/viewerlist?type=1">参观登记</el-menu-item>
              <el-menu-item index="/admin/accountmanage?type=2">参展登记</el-menu-item>
              <el-menu-item index="/admin/reserveslist?type=3">预约公司</el-menu-item>
              <el-menu-item index="/admin/personList?type=4">参展人员</el-menu-item>
            </el-submenu>

            <!-- 活动管理 -->
            <el-menu-item index="/admin/activitylist">
              <i class="el-icon-date"></i>
              <span>活动管理</span>
            </el-menu-item>

            <!-- 展会管理 -->
            <el-submenu index="exhibition">
              <template slot="title">
                <i class="el-icon-office-building"></i>
                <span>展会管理</span>
              </template>
              <el-menu-item index="/admin/eventinfo?type=1">展会介绍</el-menu-item>
              <el-menu-item index="/admin/eventtrip?type=3">展会安排</el-menu-item>
              <el-menu-item index="/admin/eventroute?type=4">交通指南</el-menu-item>
              <el-menu-item index="/admin/eventcontact?type=5">联系我们</el-menu-item>
              <el-menu-item index="/admin/eventdownload?type=6">展会资料</el-menu-item>
            </el-submenu>

            <!-- 新闻报道 -->
            <el-submenu index="news">
              <template slot="title">
                <i class="el-icon-document"></i>
                <span>新闻报道</span>
              </template>
              <el-menu-item index="/admin/eventmanage?type=1">小程序端</el-menu-item>
              <el-menu-item index="/admin/stationinfolist?type=2">展商端</el-menu-item>
            </el-submenu>

            <!-- 新锐制造大赏 -->
            <el-menu-item index="/admin/product_vote">
              <i class="el-icon-trophy"></i>
              <span>新创产品大赏</span>
            </el-menu-item>

            <!-- 选展器 -->
            <el-submenu index="survey">
              <template slot="title">
                <i class="el-icon-search"></i>
                <span>选展器</span>
              </template>
              <el-menu-item index="/admin/surveyList?type=1">展会列表</el-menu-item>
              <el-menu-item index="/admin/survey_other?type=2">投票详情</el-menu-item>
              <el-menu-item index="/admin/survey_message?type=3">留言</el-menu-item>
            </el-submenu>

            <!-- 广告管理 -->
            <el-menu-item index="/admin/admanage">
              <i class="el-icon-picture"></i>
              <span>广告管理</span>
            </el-menu-item>

            <!-- 反馈信息 -->
            <el-menu-item index="/admin/newlist">
              <i class="el-icon-chat-dot-round"></i>
              <span>反馈信息</span>
            </el-menu-item>

            <!-- 小程序用户 -->
            <el-menu-item index="/admin/wxuser">
              <i class="el-icon-phone"></i>
              <span>小程序用户</span>
            </el-menu-item>

            <!-- 名片投递 -->
            <el-menu-item index="/admin/card">
              <i class="el-icon-postcard"></i>
              <span>名片投递</span>
            </el-menu-item>

            <!-- 账号管理（仅超级管理员可见） -->
            <el-menu-item v-if="is_superuser" index="/admin/account">
              <i class="el-icon-setting"></i>
              <span>账号管理</span>
            </el-menu-item>

            <!-- 获取短链接 -->
            <el-menu-item index="/admin/short_link">
              <i class="el-icon-link"></i>
              <span>获取短链接</span>
            </el-menu-item>

            <!-- 展商海报生成 -->
            <el-menu-item index="/admin/poster">
              <i class="el-icon-picture-outline"></i>
              <span>展商海报生成</span>
            </el-menu-item>
          </el-menu>
        </el-scrollbar>
      </el-aside>

      <!-- 右侧：头部 + 内容 -->
      <el-container class="admin-right">
        <!-- 顶部头部 -->
        <el-header class="admin-header">
          <div class="admin-header__inner">
            <div></div>
            <div class="admin-header__user">
              <el-dropdown trigger="click">
                <span class="admin-header__username">
                  {{ name }}
                  <i class="el-icon-arrow-down"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item>
                    <div @click="LogOut">退出登录</div>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </el-header>

        <!-- 内容区域 -->
        <el-main class="admin-main">
          <router-view :include="path"></router-view>
        </el-main>
      </el-container>
    </el-container>
</template>

<script>
import api from "../utils/api";

export default {
  name: "Admin",
  data() {
    return {
      /** 缓存的路由名称，用于 keep-alive */
      path: this.$route.name,
      /** 当前用户名 */
      name: localStorage.getItem("name"),
      /** 是否为超级管理员 */
      is_superuser: localStorage.getItem("is_superuser"),
    };
  },
  computed: {
    /** 当前激活的菜单项 index（完整路径+query） */
    activeMenu() {
      const path = this.$route.path;
      const type = this.$route.query.type;
      if (type && ['/admin/cnGlobalList', '/admin/promotion',
        '/admin/viewerlist', '/admin/accountmanage', '/admin/reserveslist', '/admin/personList',
        '/admin/eventinfo', '/admin/eventtrip', '/admin/eventroute', '/admin/eventcontact',
        '/admin/eventdownload', '/admin/eventmanage', '/admin/stationinfolist',
        '/admin/surveyList', '/admin/survey_other', '/admin/survey_message'].includes(path)) {
        return path + '?type=' + type;
      }
      return path;
    },
    /** 默认展开的子菜单 */
    openedMenus() {
      const path = this.$route.path;
      const submenuMap = {
        '/admin/cnGlobalList': 'matching',
        '/admin/promotion': 'promotion',
        '/admin/viewerlist': 'visitors',
        '/admin/accountmanage': 'visitors',
        '/admin/reserveslist': 'visitors',
        '/admin/personList': 'visitors',
        '/admin/eventinfo': 'exhibition',
        '/admin/eventtrip': 'exhibition',
        '/admin/eventroute': 'exhibition',
        '/admin/eventcontact': 'exhibition',
        '/admin/eventdownload': 'exhibition',
        '/admin/eventmanage': 'news',
        '/admin/stationinfolist': 'news',
        '/admin/survey': 'survey',
      };
      for (const [prefix, submenu] of Object.entries(submenuMap)) {
        if (path.startsWith(prefix)) {
          return [submenu];
        }
      }
      return [];
    }
  },
  created() {
    this.loadConfig();
  },
  methods: {
    /**
     * 加载系统配置
     * 获取配置 ID 并存储到 localStorage
     */
    loadConfig() {
      let url = this.baseUrl + "/admin/config/";
      api.fetchData(url).then((res) => {
        let id = res[0].id;
        localStorage.setItem("config_id", id);
      });
    },

    /**
     * 退出登录
     * 弹出确认框，确认后清除 Token 并跳转到登录页
     */
    LogOut() {
      this.$confirm("将退出登录，是否继续", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        localStorage.removeItem("adminToken");
        this.$message({ message: "退出成功", type: "success" });
        this.$router.push({ name: "adminLogin" });
      });
    },
  },
};
</script>

<style scoped>
/* 整体布局 */
.admin-layout {
  min-height: 100%;
  height: 100vh;
}

/* 右侧容器（头部 + 内容） */
.admin-right {
  flex-direction: column;
  min-width: 0;
}

/* 深蓝色侧边栏（vue-element-admin 风格） */
.admin-sidebar {
  width: 210px !important;
  background-color: #304156;
  overflow: hidden;
  height: 100vh;
  padding: 0 !important;
  box-sizing: border-box;
}

::v-deep .el-aside {
  padding: 0 !important;
}

/* 侧边栏顶部标题 */
.sidebar-title {
  width: 210px;
  max-width: 100%;
  height: 50px;
  line-height: 50px;
  text-align: center;
  font-size: 15px;
  font-weight: 700;
  color: #ffffff;
  background-color: #304156;
  letter-spacing: 1px;
  box-sizing: border-box;
  overflow: hidden;
  white-space: nowrap;
}

/* 侧边栏滚动区域高度 */
.admin-sidebar .el-scrollbar {
  height: calc(100vh - 50px);
}

/* 顶部头部 */
.admin-header {
  height: var(--header-height, 60px) !important;
  line-height: var(--header-height, 60px);
  padding: 0;
  background-color: var(--header-bg, #ffffff);
  border-bottom: 1px solid var(--header-border, #e2e8f0);
  display: flex;
  align-items: center;
}

.admin-header__inner {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
}

.admin-header__user {
  padding-right: var(--spacing-lg, 24px);
}

.admin-header__username {
  font-size: 14px;
  color: var(--text-secondary, #64748b);
  cursor: pointer;
}

/* 侧边栏激活态 */
::v-deep .el-menu-item.is-active {
  background-color: #263445 !important;
}

::v-deep .el-menu-item-group__title {
  padding: 0;
}

/* 子菜单项样式 */
::v-deep .el-submenu .el-menu-item {
  min-width: auto !important;
  padding-left: 50px !important;
}

/* 菜单项图标间距 */
::v-deep .el-menu-item i,
::v-deep .el-submenu__title i {
  margin-right: 8px;
}

/* 移除菜单右侧留白 */
::v-deep .el-menu {
  border-right: none;
  padding-right: 0;
}

/* 滚动条容器去除右侧间隙 */
::v-deep .el-scrollbar__wrap {
  margin-right: 0 !important;
  overflow-x: hidden !important;
}

/* 内容区域 */
.admin-main {
  padding: 0;
  background-color: var(--content-bg, #f1f5f9);
  overflow: auto;
}

.el-container {
  min-height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin.vue